const roles = {
  DASHBOARD_USER: "DASHBOARD_USER",
  ADMIN: "ADMIN",
  NPHL_VIEWER: "NPHL_VIEWER",
  FSNRL_VIEWER: "FSNRL_VIEWER",
  NMRL_VIEWER: "NMRL_VIEWER",
  NIC_VIEWER: "NIC_VIEWER",
  GMSL_VIEWER: "GMSL_VIEWER",
  NOBRL_VIEWER: "NOBRL_VIEWER",
  NHRL_VIEWER: "NHRL_VIEWER",
  NVRL_VIEWER: "NVRL_VIEWER",
  COE_VIEWER: "COE_VIEWER",
};

const rolePrettyNames = {
  DASHBOARD_USER: "No Lab Assigned",
  ADMIN: "Admin",
  NPHL_VIEWER: "NPHL",
  FSNRL_VIEWER: "Food Lab",
  NMRL_VIEWER: "Micro Lab",
  NIC_VIEWER: "NIC",
  GMSL_VIEWER: "Genomics",
  NOBRL_VIEWER: "Oncology Lab",
  NHRL_VIEWER: "HIV Lab",
  NVRL_VIEWER: "Virology Lab",
  COE_VIEWER: "COE",
};

// Maps lab filter keys to their corresponding viewer roles
const labRoleMap = {
  NHRL: roles.NHRL_VIEWER,
  NMRL: roles.NMRL_VIEWER,
  FSNRL: roles.FSNRL_VIEWER,
  NIC: roles.NIC_VIEWER,
  GMSL: roles.GMSL_VIEWER,
  NVRL: roles.NVRL_VIEWER,
  COE: roles.COE_VIEWER,
  NOBRL: roles.NOBRL_VIEWER,
};

const adminRoles = [roles.ADMIN];
const fsnrlRoles = [roles.ADMIN, roles.NPHL_VIEWER, roles.FSNRL_VIEWER];
const nmrlRoles = [roles.ADMIN, roles.NPHL_VIEWER, roles.NMRL_VIEWER];
const nicRoles = [roles.ADMIN, roles.NPHL_VIEWER, roles.NIC_VIEWER];
const gmslRoles = [roles.ADMIN, roles.NPHL_VIEWER, roles.GMSL_VIEWER];
const nobrlRoles = [roles.ADMIN, roles.NPHL_VIEWER, roles.NOBRL_VIEWER];
const nhrlRoles = [roles.ADMIN, roles.NPHL_VIEWER, roles.NHRL_VIEWER];
const nvrlRoles = [roles.ADMIN, roles.NPHL_VIEWER, roles.NVRL_VIEWER];
const coeRoles = [roles.ADMIN, roles.NPHL_VIEWER, roles.COE_VIEWER];
const anyDashboardRoles = [
  roles.ADMIN,
  roles.NPHL_VIEWER,
  roles.FSNRL_VIEWER,
  roles.NMRL_VIEWER,
  roles.NIC_VIEWER,
  roles.GMSL_VIEWER,
  roles.NOBRL_VIEWER,
  roles.NHRL_VIEWER,
  roles.NVRL_VIEWER,
  roles.COE_VIEWER,
];
const allRoles = Object.keys(roles);

export {
  roles,
  rolePrettyNames,
  labRoleMap,
  allRoles,
  adminRoles,
  fsnrlRoles,
  nmrlRoles,
  nicRoles,
  gmslRoles,
  nobrlRoles,
  nhrlRoles,
  nvrlRoles,
  coeRoles,
  anyDashboardRoles,
};